import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import Main from "../shared/layout";
import NotFound from "../containers/not-found";

const Routes: React.FC = () => {
  const publicUrl = process.env.PUBLIC_URL;

  return (
    <>
      <Router>
        <Switch>
          <Route path={`${publicUrl}/not-found`} exact component={NotFound} />
          <Route path={`${publicUrl}`} component={Main} />
          <Redirect to={{ pathname: `${publicUrl}/not-found` }} />
        </Switch>
      </Router>
    </>
  );
};

export default Routes;
